import { readLocalStorageValue } from "@mantine/hooks";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { MN_SELECTED_MUSEUM_ID_KEY } from "@/shared/utils/constants";

export const Route = createFileRoute("/_app/")({
  beforeLoad: ({ context }) => {
    if (context.user.isSignedIn && !context.organization.membership?.role) {
      console.error("User does not have a role");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
      return;
    }

    const accessibleLocations = context.locations;

    if (!accessibleLocations || accessibleLocations.length === 0) {
      redirect({
        to: "/museum",
        throw: true,
      });
      return;
    }

    const savedMuseumIdSelection = readLocalStorageValue<string | null>({
      key: MN_SELECTED_MUSEUM_ID_KEY,
    });

    if (
      savedMuseumIdSelection &&
      accessibleLocations.find((l) => l.id === savedMuseumIdSelection)
    ) {
      redirect({
        to: "/museum/$museumId/bookings",
        params: { museumId: savedMuseumIdSelection },
        throw: true,
      });
      return;
    }

    redirect({
      to: "/museum/$museumId/bookings",
      params: { museumId: accessibleLocations[0].id },
      throw: true,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
